import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private cookieService: CookieService,
    private httpClient: HttpClient,
    private jwtHelper: JwtHelperService,
    private router: Router,
  ) {}

  // get token field value
  public getTokenFieldValue(field: string): any {
    if(!field || !this.cookieService.get('token')) return;
    return _.get(this.jwtHelper.decodeToken(this.cookieService.get('token')), field);
  }

  // check user role
  public hasRole(roles: string[]): boolean {
    return !!_.intersection(this.getTokenFieldValue('roles'), roles).length;
  }

  // [POST] service to log in
  public login(form: { [index: string]: any }): Observable<object> {
    const credentials: { [index: string]: any } = {
      username: _.get(form, 'username'),
      password: _.get(form, 'password')
    };
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + environment.api_endpoints.login, credentials, {
        params: {}, withCredentials: false, observe: 'response'
      });
  }

  // function to log out
  public logout(): void {
    this.cookieService.deleteAll(`/`);
    this.router.navigate(['login']);
  }
}
